import styled from 'styled-components'

import { style } from 'theme'

export const Center = styled.div`
  min-height: 200px;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledHeroHeader = styled.div`
  font-size: 22px;
  line-height 30px;
  margin: 30px auto 40px;
  text-align: center;
  max-width: 400px;
  font-weight: bold;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 340px;
    font-size: 14px;
    line-height: 22px;
    margin: 0px auto 30px;
    font-weight: normal;
  }
  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`
